import { getCode } from 'country-list';
import { CookieStorage } from 'cookie-storage';
import { cleanLangURL, getSelectedRegionString } from '../utils/regionUtil';
import BurgerMenu from './burger-menu';
import { initModal, toggleModal } from './modal';
export const cookieStorage = new CookieStorage({
    path: '/',
});
export const redirectToRegion = (region, language, currency, isDefault, redirectPath) => {
    if (region === 'GB' || region === 'GBR') {
        region = 'UK';
    }
    // This assumes all our permanent domains are in the following format: rationale-<countryCode>-<environment>
    const environment = window.permanentDomain.split('.')[0].split('-')[2];
    // Filter out other regions and remove language from pathname before redirecting
    const path = redirectPath || cleanLangURL();
    const expires = new Date();
    const days = 30;
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStorage.setItem('rrLastSelection', `${region}`, {
        path: '/',
        expires,
    });
    if (!Shopify.designMode) {
        if (language && currency) {
            window.location.href = `https://rationale-${region.toLowerCase()}-${environment}.myshopify.com/${isDefault ? '' : language}${path || ''}?currency=${currency}&m=1&r=${region}`;
        }
        else {
            window.location.href = `https://rationale-${region.toLowerCase()}-${environment}.myshopify.com${path || ''}?m=1`;
        }
    }
};
const setSwitchButtons = () => {
    const regionButtons = document.querySelectorAll('[data-region-prompt]');
    const regionTags = document.querySelectorAll('[data-region-tag]');
    const languageButtons = document.querySelectorAll('[data-language-prompt]');
    const selectedRegion = getSelectedRegionString();
    if (regionButtons && regionButtons.length > 0) {
        regionButtons.forEach((regButton) => {
            const regButtonHTML = regButton;
            const title = selectedRegion.split('[]')[5];
            regButtonHTML.innerHTML = `${title} -`;
        });
    }
    if (regionTags && regionTags.length > 0 && selectedRegion) {
        regionTags.forEach((regTag) => {
            const regTagHTML = regTag;
            const country = selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.split('[]')[0];
            if (regTagHTML) {
                const currentValue = regTagHTML.value;
                regTagHTML.value = `${country}, ${currentValue}`;
            }
        });
    }
    if (languageButtons && languageButtons.length > 0 && selectedRegion) {
        languageButtons.forEach((langButton) => {
            const langButtonHTML = langButton;
            const lang = selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.split('[]')[3];
            langButtonHTML.innerHTML = `${lang} -`;
        });
    }
    let selectedRegionArray = selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.split('[]');
    if (!selectedRegionArray)
        return;
    const localeSvgs = document.querySelectorAll(`.header__language .locale-icon--${selectedRegionArray[1].toLowerCase()}`);
    const localeDisplays = document.querySelectorAll('[data-locale-display]');
    if (localeDisplays) {
        localeSvgs.forEach((localeSvg) => {
            debugger;
            localeSvg.classList.add('locale-icon--active');
        });
        localeDisplays.forEach((localeDisplay) => {
            localeDisplay.innerHTML = window.theme.moneyFormat.replace('{{amount}}', '');
        });
    }
};
const init = () => {
    initModal('region-selector');
    setSwitchButtons();
    const regionSelectors = document.querySelectorAll('[data-region-selector]');
    if (regionSelectors) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < regionSelectors.length; i++) {
            const regionSelector = regionSelectors[i];
            regionSelector.addEventListener('click', (event) => {
                event.preventDefault();
                // This is required when the region selector is opened from the burger menu button to prevent the event propagating to the background
                event.stopPropagation();
                BurgerMenu.close();
                toggleModal('region-selector');
            });
        }
    }
    document.querySelectorAll('.region-selector button[data-region-button]').forEach((regionButton) => {
        regionButton.addEventListener('click', (event) => {
            event.preventDefault();
            const regionInfo = regionButton.dataset.regionId.split('[]');
            const language = regionInfo[2];
            const currency = regionInfo[1];
            let region = regionInfo[0];
            const isDefault = regionInfo[4] === 'true';
            if (region) {
                if (region === 'United Kingdom') {
                    region = 'United Kingdom of Great Britain and Northern Ireland';
                }
                let regionCode = getCode(region);
                if (regionCode === 'GB') {
                    regionCode = 'UK';
                }
                if (window.location.href.indexOf('/checkouts/') !== -1) {
                    return redirectToRegion(regionCode, language, currency, isDefault, '/cart');
                }
                return redirectToRegion(regionCode, language, currency, isDefault);
            }
            return null;
        });
    });
    const regionAlert = document.querySelector('.region-alert__close');
    regionAlert === null || regionAlert === void 0 ? void 0 : regionAlert.addEventListener('click', (event) => {
        var _a;
        event.preventDefault();
        (_a = regionAlert.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove('region-alert--shown');
        document.body.classList.remove('body-region-alert--shown');
        localStorage.setItem('regionAlertShown', 'true');
    });
};
export default init;
